import { render, staticRenderFns } from "./good.vue?vue&type=template&id=cd922592&scoped=true"
import script from "./good.vue?vue&type=script&lang=js"
export * from "./good.vue?vue&type=script&lang=js"
import style0 from "./good.vue?vue&type=style&index=0&id=cd922592&prod&lang=scss&scoped=true"
import style1 from "./good.vue?vue&type=style&index=1&id=cd922592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd922592",
  null
  
)

export default component.exports